module.exports = __webpack_public_path__ + "media/pouches/yellow-pouch-1412cb34.svg";